import { render } from "./PersonaAddLabelButton.vue?vue&type=template&id=47533098&scoped=true"
import script from "./PersonaAddLabelButton.vue?vue&type=script&lang=js"
export * from "./PersonaAddLabelButton.vue?vue&type=script&lang=js"

import "./PersonaAddLabelButton.vue?vue&type=style&index=0&id=47533098&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47533098"]])

export default __exports__